import { z } from "zod";

export const StorageBucket = {
	AVATARS: "avatars",
	FEED_MEDIA: "feed-media",
	STUDENT_CENTRAL: "student-central",
	MESSAGING_ATTACHMENTS: "messaging-attachments",
	RESUMES: "resumes",
	CHILD_DOCUMENTS: "child-documents",
} as const;

export type StorageBucket = (typeof StorageBucket)[keyof typeof StorageBucket];

export const STORAGE_BUCKETS = Object.values(StorageBucket) as readonly StorageBucket[];

export const storageBucketSchema = z.enum(StorageBucket);
